<section id="terms">
    <!-- top circle border -->
    <div class="top-rounded-border">
    </div>

    <div class="container-fluid px-5 py-4">
        <div class="n100">

            <div>
                <h3>Return and Refund Policy</h3>
                <p>Last updated: September 06, 2023</p>
                <p>
                    Thank you for shopping at Puppy's Bakery.
                </p>
                <p>The following terms are applicable for any products that You purchased with Us.</p>
                
            </div>

            <div>
                <h3>Interpretation and Definitions</h3>
                <h3>Interpretation</h3>
                <p>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </p>
                <h3>Definitions</h3>

                <p>
                    For the purposes of this Return and Refund Policy:
                </p>
                <ul>
                    <li><p> <b>Company</b>  (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Puppy's Restaurant , No.224, Theni Main Road, (Opp.Master Mahal) .</p></li>
                    <li><p> <b>Goods </b> refer to the items offered for sale on the Service.</p></li>
                    <li><p> <b>Orders  </b> mean a request by You to purchase Goods from Us.</p></li>
                    <li><p> <b>Service   </b> refers to the Website.</p></li>
                    <li><p> <b>Website    </b>refers to Puppy's Bakery, accessible from  <a style="text-decoration: underline;" href="https://puppysbakery.com/">https://puppysbakery.com/</a>  </p></li>
                    <li><p> <b>You </b>means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p></li>
                </ul>



            </div>
            <div>
                <h3>Your Order Cancellation Rights</h3>

                <p>
                    You are entitled to cancel Your Order within 7 days without giving any reason for doing so.

                </p>
                <p>
                    The deadline for cancelling an Order is 7 days from the date on which You received the Goods or on which a third party you have appointed, who is not the carrier, takes possession of the product delivered.
                </p>
                <p>
                    In order to exercise Your right of cancellation, You must inform Us of your decision by means of a clear statement. You can inform us of your decision by:
                </p>
                <ul>
                    
                    <li><p> By email:  <span><a style="text-decoration: underline;" href="mailto:mailbox@puppys.co.in">mailbox@puppys.co.in </a> </span>  </p></li>
                    <li><p> By visiting this page on our website: <a style="text-decoration: underline;" href="https://puppysbakery.com/page/contactUs">https://puppysbakery.com/page/contactUs</a>  </p></li>
                    <li><p> By phone number: <a style="text-decoration: underline;" href="tel:+918122210222"> +91 81222 10222</a>  </p></li>
                </ul>
                <p>We will reimburse You no later than 14 days from the day on which We receive the returned Goods. We will use the same means of payment as You used for the Order, and You will not incur any fees for such reimbursement.</p>



                
            </div>
            <div>
                <h3>Conditions for Returns</h3>
                <p>
                    In order for the Goods to be eligible for a return, please make sure that:
                </p>
                <ul>
                    <li><p>The Goods were purchased in the last 7 days</p></li>
                    <li><p>The Goods are in the original packaging</p></li>
                </ul>

                <p>
                    The following Goods cannot be returned:
                </p>
                <ul>
                    <li><p>The supply of Goods made to Your specifications or clearly personalized.</p></li>
                    <li><p>The supply of Goods which according to their nature are not suitable to be returned, deteriorate rapidly or where the date of expiry is over.</p></li>
                    <li><p>The supply of Goods which are not suitable for return due to health protection or hygiene reasons and were unsealed after delivery.</p></li>
                    <li><p>The supply of Goods which are, after delivery, according to their nature, inseparably mixed with other items.</p></li>
                </ul>
                <p>We reserve the right to refuse returns of any merchandise that does not meet the above return conditions in our sole discretion.</p>
                <p>Only regular priced Goods may be refunded. Unfortunately, Goods on sale cannot be refunded. This exclusion may not apply to You if it is not permitted by applicable law.</p>
                    
                
            </div>
            <div>
                <h3 >Returning Goods</h3>
                <p>
                    You are responsible for the cost and risk of returning the Goods to Us. You should send the Goods at the following address:
                </p>
                <p>No.224, Theni Main Road, <br>
                    (Opp.Master Mahal) <br>
                    Madurai - 625016.</p>
               <p>We cannot be held responsible for Goods damaged or lost in return shipment. Therefore, We recommend an insured and trackable mail service. We are unable to issue a refund without actual receipt of the Goods or proof of received return delivery.</p>

               
            </div>
            <div>
                <h3>Gifts</h3>
                <p>If the Goods were marked as a gift when purchased and then shipped directly to you, You'll receive a gift credit for the value of your return. Once the returned product is received, a gift certificate will be mailed to You.</p>
                <p>If the Goods weren't marked as a gift when purchased, or the gift giver had the Order shipped to themselves to give it to You later, We will send the refund to the gift giver.</p>
              
            </div>
            <div>
                <h3>Contact Us</h3>
                <p>If you have any questions about our Returns and Refunds Policy, please contact us:</p>
                <ul>
                    <li><p> By email:  <span><a style="text-decoration: underline;" href="mailto:mailbox@puppys.co.in">mailbox@puppys.co.in </a> </span>  </p></li>
                    <li><p> By visiting this page on our website: <a style="text-decoration: underline;" href="https://puppysbakery.com/page/contactUs">https://puppysbakery.com/page/contactUs</a>  </p></li>
                    <li><p> By phone number: <a style="text-decoration: underline;" href="tel:+918122210222"> +91 81222 10222</a>  </p></li>
                </ul>
            </div>
            
        </div>
    </div>
</section>